<template>
  <v-container fluid>
    <!-- Remove this commented header section entirely -->
    <!-- <v-row no-gutters class="header-row">...</v-row> -->

    <!-- Remove this blue divider since it's in the layout -->
    <!-- <v-divider class="blue-divider"></v-divider> -->

    <v-row class="content-row">
      <!-- <v-col cols="12" md="4">
        <v-card class="mb-4">
          <v-card-title class="red white--text">
            연결된 프로젝트
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
            <v-checkbox v-model="selectAllConnected" label="전체선택"></v-checkbox>
            <v-checkbox v-for="project in connectedProjects" :key="project.id"
                        v-model="selectedConnectedProjects"
                        :label="project.name"></v-checkbox>
          </v-card-text>
        </v-card>
        <v-btn color="grey darken-1" class="mr-2">연결 해제</v-btn>
        <v-btn color="red">대화 생성</v-btn>
        <v-btn text>선택 취소</v-btn>
      </v-col> -->

      <v-col cols="12" md="7" class="pa-6">
        <!-- <v-card outlined class="mb-4">
      <v-card-title class="py-2 grey lighten-4 text-subtitle-1">
        전체 프로젝트
      </v-card-title>
      <v-card-text class="pa-0">
        <v-list class="pa-0">
          <v-list-item class="px-3 py-1">
            <v-list-item-action class="mr-2">
              <v-checkbox v-model="selectAllProjects" dense hide-details></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="text-caption">전체선택</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item 
            v-for="project in userProjects" 
            :key="project.id" 
            class="px-3 py-1"
            @click="openProjectDetail(project)"
            style="cursor: pointer"
          >
            <v-list-item-action class="mr-2" @click.stop>
              <v-checkbox v-model="selectedProjects" :value="project.id" dense hide-details></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="text-caption">{{ project.name }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action @click.stop>
              <v-btn icon x-small @click.stop="expandProject(project.id)">
                <v-icon small>mdi-chevron-down</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card> -->
        <v-card class="mb-4">
          <v-card-title>전체 프로젝트</v-card-title>
          <v-card-text style="background-color: #f0f0f0;">
            <ProjectTreeView 
              ref="projectTree"
              :project-crawlings="projectCrawlings" 
              @project-selected="openProjectDetail"
              @create-chat="handleCreateChat" 
            />
          </v-card-text>
        </v-card>
        <v-btn 
          color="red" 
          class="mr-2" 
          @click="$refs.projectTree.createChat()"
        >
          대화 생성
        </v-btn>
        <v-btn 
          text 
          @click="$refs.projectTree.clearSelection()"
        >
          선택 취소
        </v-btn>
      </v-col>

      <v-col cols="4">
        <v-card class="new-project-registration">
          <v-card-title class="grey darken-2 white--text">
            신규 프로젝트 등록
          </v-card-title>
          <v-card-text>
            <v-row align="center" class="mb-2">
              <v-col cols="10">
                <v-text-field v-model="projectSearch" label="프로젝트 검색" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn @click="openGigProjectsModal">검색</v-btn>
              </v-col>
            </v-row>

            <v-row align="center" class="mb-2">
              <v-col cols="10">
                <v-text-field v-model="projectMembers" label="프로젝트 참여 인원" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-col cols="2">
                  <v-btn @click="openGIGUsersModal">검색</v-btn>
                  <v-btn @click="addSelectedUser">추가</v-btn>
                </v-col>
              </v-col>

            </v-row>

            <v-row>
              <v-col cols="12">
                <v-chip-group column style="max-height: 200px; overflow-y: auto;">
                  <v-chip v-for="participant in projectParticipants" :key="participant.mber_nm" small class="ma-1">
                    {{ participant.mber_nm }} ({{ participant.dty_dv_code_nm }}, {{ participant.dept_dv_code_nm }})
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon small v-bind="attrs" v-on="on" right>mdi-information-outline</v-icon>
                      </template>
                      <span>
                        {{ participant.spcy_code_nm || '분야 없음' }} |
                        {{ participant.grd_dv_code_nm }} |
                        {{ participant.gnfd_dv_code_nm }}
                      </span>
                    </v-tooltip>
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>

            <!-- <v-row align="center" class="mb-2">
              <v-col cols="8">
                <v-text-field v-model="lucyFilePath" label="Lucy 파일 경로" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn small text @click="triggerFileInput">
                  Load Lucy
                </v-btn>
                <input
                  type="file"
                  ref="fileInput"
                  style="display: none"
                  @change="handleFileUpload"
                  accept=".xlsx,.xls,.csv"
                >
              </v-col>
            </v-row> -->

            <v-chip-group v-model="selectedKeywords" column multiple>
              <v-chip v-for="keyword in keywords" :key="keyword.text" :color="keyword.color" text-color="white" small>
                {{ keyword.text }}
              </v-chip>
            </v-chip-group>

            <v-row align="center" class="mb-2">
              <!-- <v-col cols="10">
                <v-btn-toggle v-model="selectedSources" multiple>
                  <v-btn small outlined>언론</v-btn>
                  <v-btn small outlined>블로그</v-btn>
                  <v-btn small outlined>인스타그램</v-btn>
                  <v-btn small outlined>X</v-btn>
                  <v-btn small outlined>커뮤니티</v-btn>
                  <v-btn small outlined>유튜브</v-btn>
                </v-btn-toggle>
              </v-col> -->
              <!-- <v-col cols="2">
                <v-btn small text @click="triggerFileInput">
                  Load Lucy
                </v-btn>
                <input
                  type="file"
                  ref="fileInput"
                  style="display: none"
                  @change="handleFileUpload"
                >
              </v-col> -->
            </v-row>

            <v-row class="mb-2">
              <!-- <v-col cols="4">
                <v-menu ref="startMenu" v-model="startMenu" :close-on-content-click="false"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="startDate" label="Start" readonly v-bind="attrs" v-on="on" outlined dense
                      hide-details></v-text-field>
                  </template>
                  <v-date-picker v-model="startDate" @input="startMenu = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4">
                <v-menu ref="endMenu" v-model="endMenu" :close-on-content-click="false" transition="scale-transition"
                  offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="endDate" label="End" readonly v-bind="attrs" v-on="on" outlined dense
                      hide-details></v-text-field>
                  </template>
                  <v-date-picker v-model="endDate" @input="endMenu = false"></v-date-picker>
                </v-menu>
              </v-col> -->
              <!-- <v-col cols="4">
      <v-btn color="primary" @click="startCrawling" :loading="isProcessing" :disabled="!lucyFile">크롤링 시작</v-btn>
    </v-col> -->
            </v-row>
          </v-card-text>
          <v-btn color="red" block @click="createNewProject">등록</v-btn>

        </v-card>
      </v-col>

    </v-row>
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="3000">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
      </template>
    </v-snackbar>

    <v-row>
    <v-col cols="12">
      <h3>대화 히스토리</h3>
      <v-sheet class="mx-auto" max-width="100%">
        <v-slide-group show-arrows>
          <v-slide-item v-for="session in chatSessions" :key="session.id">
            <v-card class="ma-2" width="300" @click="openChatSession(session)" style="cursor: pointer">
              <v-card-title>{{ session.title }}</v-card-title>
              <v-card-subtitle>생성일: {{ formatDate(session.created_at) }}</v-card-subtitle>
              <v-card-text>{{ session.summary }}</v-card-text>
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </v-sheet>
    </v-col>
  </v-row>

    <GIGProjectGridModal v-model:show="showGIGProjectsModal" @close="closeGIGProjectsModal" @select="selectProject" />
  </v-container>
  <v-dialog v-model="messageDialog" max-width="300">
    <v-card>
      <v-card-title class="headline">{{ messageTitle }}</v-card-title>
      <v-card-text>{{ messageContent }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="messageDialog = false">닫기</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="messageDialog2" max-width="300">
    <v-card>
      <v-card-title class="headline">{{ messageTitle }}</v-card-title>
      <v-card-text>{{ messageContent }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="confirmHandler">확인</v-btn>
        <v-btn color="red darken-1" text @click="cancelHandler">취소</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <GIGUserGridModal v-model:show="showGIGUsersModal" @close="closeGIGUsersModal" @select="selectGIGUser" />
  <ProjectDetailModal v-model="showProjectDetailModal" :project-data="selectedProjectData"
    @close="closeProjectDetailModal" @show-message="handleShowMessage" />
  
  <ProjectTreeView @project-selected="openProjectDetail" />


  <v-treeview :items="treeItems" item-key="id" activatable return-object @update:active="handleNodeClick"
    :key="treeKey">
    <template v-slot:label="{ item }">
      <div :class="{ 'project-item': item.type === 'project', 'crawling-item': item.type === 'crawling' }">
        {{ item.name }}
      </div>
    </template>
  </v-treeview>

  <!-- 채팅 세션 목록 -->
  <div class="chat-sessions">
    <h3>채팅 세션 목록</h3>
    <ul>
      <li v-for="session in chatSessions" :key="session.id">
        <a href="#" @click.prevent="openChatSession(session)">
          {{ session.title || 'Untitled Session' }}
        </a>
      </li>
    </ul>
  </div>
</template>




<script>
import { defineComponent, ref, computed, onMounted, reactive } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import GIGUserGridModal from '@/components/GIGUserGridModal.vue'
import ProjectDetailModal from '@/components/ProjectDetailModal.vue'
import GIGProjectGridModal from '@/components/GIGProjectGridModal.vue'
import ProjectTreeView from '@/components/ProjectTreeView.vue'



export default defineComponent({
  name: 'MainView',
  components: {
    GIGUserGridModal,
    ProjectDetailModal,
    GIGProjectGridModal,
    ProjectTreeView,
  },
  setup() {
    const store = useStore()
    console.log('Store state:', store.state.project)

    const selectAllConnected = ref(false)
    const selectAllProjects = ref(false)
    const selectedConnectedProjects = ref([])
    const selectedProjects = ref([])
    const searchModalOpen = ref(false)
    const startMenu = ref(false)
    const endMenu = ref(false)
    const newProject = ref({
      name: '',
      participants: '',
      crawlingKeywords: [],
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
    })
    const historyItems = ref([
      {
        title: '대화 요약: xx홍보를 위한 인사이트 도출',
        subtitle: '대화 생성: 2024.07.01 (~25.01.31)',
      },
      {
        title: '대화 요약: 제안서 작성',
        subtitle: '대화 생성: 2024.07.31 (25.02.28)',
      }
    ])
    const projectSearch = ref('')
    const projectMembers = ref('')
    const selectedProject = ref(null)
    const messageDialog = ref(false)
    const messageDialog2 = ref(false)
    const messageTitle = ref('')
    const messageContent = ref('')
    const loading = ref(false)

    const lucyFilePath = ref('')
    const lucyFile = ref(null)
    const fileInput = ref(null)
    const snackbar = reactive({
      show: false,
      text: '',
      color: 'info'
    })
    const chatSessions = ref([]);

    const isUploading = computed(() => store.getters['crawling/isUploading'])
    const uploadError = computed(() => store.getters['crawling/uploadError'])
    const uploadSuccess = computed(() => store.getters['crawling/uploadSuccess'])

    const currentUser = computed(() => store.state.auth.user)
    const allProjects = computed(() => store.state.project.projects)
    const projectParticipants = computed(() => store.state.project.projectParticipants)
    const connectedProjects = computed(() => allProjects.value.filter(project => project.isConnected))
    const userProjects = computed(() => store.state.project.userProjects)
    const isProcessing = computed(() => store.state.crawling.isProcessing)



    const fetchGIGProjects = () => store.dispatch('project/fetchGIGProjects')
    const createProjectAction = (project) => store.dispatch('project/createProject', project)
    const fetchProjectParticipants = (id) => store.dispatch('project/fetchProjectParticipants', id)
    const fetchUserProjects = async () => {
      await store.dispatch('project/fetchUserProjects')
    }

    const toggleAllConnected = () => {
      if (selectAllConnected.value) {
        selectedConnectedProjects.value = connectedProjects.value.map(project => project.id)
      } else {
        selectedConnectedProjects.value = []
      }
    }

    const toggleAllProjects = () => {
      if (selectAllProjects.value) {
        selectedProjects.value = allProjects.value.map(project => project.id)
      } else {
        selectedProjects.value = []
      }
    }

    const createProject = async () => {
      try {
        await createProjectAction(newProject.value)
        newProject.value = {
          name: '',
          participants: '',
          crawlingKeywords: [],
          startDate: new Date().toISOString().substr(0, 10),
          endDate: new Date().toISOString().substr(0, 10),
        }
        fetchGIGProjects()
      } catch (error) {
        console.error('Failed to create project:', error)
      }
    }

    const selectProject = async (project) => {
      console.log('Selected project:', project)
      selectedProject.value = project
      projectSearch.value = project.prjct_nm
      searchModalOpen.value = false

      try {
        await fetchProjectParticipants(project.prjct_pid)
        console.log('Project participants:', projectParticipants.value)
        projectMembers.value = `${projectParticipants.value.length} 명`
      } catch (error) {
        console.error('Failed to fetch project participants:', error)
        projectMembers.value = 'Error fetching participants'
      }
    }

    const showGIGProjectsModal = ref(false)

    const openGigProjectsModal = async () => {
      loading.value = true
      try {
        await store.dispatch('project/fetchGIGProjects')
        showGIGProjectsModal.value = true
      } catch (error) {
        console.error('Failed to search projects:', error)
        showSnackbar('프로젝트 검 중 오류가 발생했습니다.', 'error')
      } finally {
        loading.value = false
      }
    }

    const closeGIGProjectsModal = () => {
      showGIGProjectsModal.value = false
    }

    const clearSelection = () => {
      selectedConnectedProjects.value = []
      selectedProjects.value = []
      selectAllConnected.value = false
      selectAllProjects.value = false
      selectedProject.value = null
      projectSearch.value = ''
      projectMembers.value = ''
      userProjects.value = []
    }

    const createNewProject = async () => {
      if (!selectedProject.value) {
        showMessage('오류', '프로젝트를 선택해주세요.')
        return
      }
      console.log(currentUser.value)
      const participantIds = projectParticipants.value
        ? [...new Set([currentUser.value.pid, ...projectParticipants.value.map(p => p.mber_pid)])]
        : [currentUser.value.pid]

      try {
        const newProject = {
          gig_project_id: selectedProject.value.prjct_pid,
          name: selectedProject.value.prjct_nm,
          description: selectedProject.value.prjct_contents || null,
          status: 'active',
          type: 'gig',
          start_date: selectedProject.value.prjct_bgng_dt || new Date().toISOString().split('T')[0],
          end_date: selectedProject.value.prjct_end_dt || new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
          participant_ids: participantIds
        }
        console.log('Creating new project:', newProject)

        const result = await createProjectAction(newProject)
        if (result.success) {
          showMessage('성공', '프로젝트가 성공적으로 생성되었습니다.')
          clearSelection()
        } else {
          showMessage('실패', '프로젝트 생성에 실패했습니다.')
        }
      } catch (error) {
        console.error('Failed to create project:', error)
        showMessage('오류', '프로젝트 생성 중 오류가 발생했습니다.')
      }
    }

    const showMessage = (title, content) => {
      messageTitle.value = title
      messageContent.value = content
      messageDialog.value = true
    }

    const triggerFileInput = () => {
      fileInput.value.click()
    }

    const handleFileUpload = (event) => {
      const file = event.target.files[0]
      if (file) {
        const fileExtension = file.name.split('.').pop().toLowerCase()
        if (['xlsx', 'xls', 'csv'].includes(fileExtension)) {
          lucyFile.value = file
          lucyFilePath.value = file.name
        } else {
          showSnackbar('Excel 파일 (.xlsx, .xls, .csv)만 업로드 가능합니다.', 'error')
          event.target.value = '' // Reset file input
        }
      }
    }

    const startCrawling = async () => {
      if (!selectedProject.value) {
        showSnackbar('프로젝트를 선택해주세요.', 'warning')
        return
      }

      // if (!lucyFile.value) {
      //   messageTitle.value = '확인'
      //   messageContent.value = '크롤링 작업 없이 프로젝트를 등록 하시겠습니까? 크롤링 작업은 프로젝트 세부 창에서 등록이 가능합니다.'
      //   messageDialog2.value = true
      //   return
      // }

      await processCrawling()
    }

    const processCrawling = async () => {
      try {
        const formData = new FormData()
        if (lucyFile.value) {
          formData.append('file', lucyFile.value)
        }
        formData.append('selected_project_id', selectedProject.value.prjct_pid)

        const response = await store.dispatch('crawling/startCrawling', {
          file: lucyFile.value,
          selected_project_id: selectedProject.value.prjct_pid
        })

        if (response.success) {
          showSnackbar(lucyFile.value ? '크롤링이 시작되었습니다.' : '프로젝트가 등록되었습니다.', 'success')
        } else {
          throw new Error(response.message || '작업 시작에 실패했습니다.')
        }
      } catch (error) {
        showSnackbar(error.message || '작업 시작 중 오류가 발생했습니다.', 'error')
      }
    }

    const uploadLucyTest = async () => {
      if (!lucyFile.value) {
        showMessage('오류', 'Lucy 파일을 선택해주세요.')
        return
      }

      await store.dispatch('crawling/uploadLucyFile', {
        file: lucyFile.value,
        userPid: currentUser.value.pid
      })

      if (uploadSuccess.value) {
        showMessage('성공', 'Lucy 파일이 성공적으로 업로드되었습니다.')
        // Here you can add logic to start the crawling process if needed
      } else if (uploadError.value) {
        showMessage('실패', uploadError.value)
      }
    }

    const showSnackbar = (text, color = 'info') => {
      snackbar.value.show = true
      snackbar.value.text = text
      snackbar.value.color = color
    }

    const confirmHandler = async () => {
      messageDialog2.value = false
      try {
        if (!lucyFile.value) {
          await createNewProject()
        } else {
          await processCrawling()
        }
        await reloadProjects()
      } catch (error) {
        console.error('Error in confirmHandler:', error)
        showSnackbar('작업 수행중 에러가 발생했습니다', 'error')
      }
    }

    const cancelHandler = () => {
      messageDialog2.value = false
    }

    const reloadProjects = async () => {
      await fetchUserProjects()
      clearSelection()
    }

    const showGIGUsersModal = ref(false)

    const openGIGUsersModal = async () => {
      await store.dispatch('user/fetchGigUsers')
      showGIGUsersModal.value = true
    }

    const closeGIGUsersModal = () => {
      showGIGUsersModal.value = false
    }

    const selectGIGUser = (employee) => {
      projectMembers.value += (projectMembers.value ? ', ' : '') + employee.mber_nm
      selectedGIGUser.value = employee
      closeGIGUsersModal()
    }
    const formatDate = (dateStr) => {
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return new Date(dateStr).toLocaleDateString('ko-KR', options);
    };

    // Add this computed property
    //const projectCrawlings = computed(() => store.state.project.projectCrawlings)

    const projectCrawlings = computed(() => {
      const data = store.state.project.projectCrawlings
      console.log('Project crawlings:', data) // Debug line
      return data || []
    })

    // Add this to your onMounted
    onMounted(async () => {
      // fetchProjects()
      // await fetchUserProjects()
      await fetchChatSessions();
      try {
        console.log('Fetching project crawlings...') // Debug line
        await store.dispatch('project/fetchProjectCrawlings')
        console.log('Fetch complete:', store.state.project.projectCrawlings) // Debug line
      } catch (error) {
        console.error('Failed to fetch project crawlings:', error)
        showSnackbar('프로젝트 로딩 중 오류가 발생했습니다.', 'error')
      }
    })

    const showProjectDetailModal = ref(false)
    const selectedProjectData = ref(null)

    const openProjectDetail = (project) => {
      console.log('Opening project detail:', project) // Debug
      selectedProjectData.value = project
      showProjectDetailModal.value = true
    }

    const closeProjectDetailModal = () => {
      showProjectDetailModal.value = false
      selectedProjectData.value = null
    }

    const selectedGIGUser = ref(null)


    const addSelectedUser = () => {
      if (!selectedGIGUser.value) {
        showMessage('오류', '사용자를 먼저 선택해주세요.')
        return
      }

      const newParticipant = {
        mber_pid: selectedGIGUser.value.mber_pid,
        mber_nm: selectedGIGUser.value.mber_nm,
        dty_dv_code_nm: selectedGIGUser.value.dty_dv_code_nm,
        dept_dv_code_nm: selectedGIGUser.value.dept_dv_code_nm
      }

      // Check if user already exists
      const exists = projectParticipants.value.some(p => p.mber_pid === newParticipant.mber_pid)
      if (!exists) {
        projectParticipants.value.push(newParticipant)
      } else {
        showMessage('알림', '이미 추가된 사용자입니다.')
      }
    }

    const router = useRouter()

    const handleCreateChat = (selectedJobs) => {
      console.log('Selected crawling jobs:', selectedJobs);
      
      if (selectedJobs.length > 0) {
        router.push({
          name: 'Chat',
          query: {
            selectedJobs: JSON.stringify(selectedJobs),
            sessionId: null,
          },
        });
      }
    };

    const projectTree = ref(null)

    const handleShowMessage = ({ title, content }) => {
      console.log('handleShowMessage called with:', title, content) 
      showSnackbar(content, 'info')
    }

    const fetchChatSessions = async () => {
      try {
        await store.dispatch('chat/fetchChatSessions');
        chatSessions.value = store.state.chat.sessions;
      } catch (error) {
        console.error('Failed to fetch chat sessions:', error);
      }
    };
    const openChatSession = (session) => {
      router.push({
        name: 'Chat',
        query: {
          sessionId: session.id,
        },
      });
    };

    return {
      selectAllConnected,
      selectAllProjects,
      selectedConnectedProjects,
      selectedProjects,
      searchModalOpen,
      startMenu,
      endMenu,
      newProject,
      historyItems,
      projectSearch,
      projectMembers,
      selectedProject,
      messageDialog,
      messageDialog2,
      messageTitle,
      messageContent,
      loading,
      currentUser,
      userProjects,
      allProjects,
      projectParticipants,
      connectedProjects,
      toggleAllConnected,
      toggleAllProjects,
      createProject,
      selectProject,
      openGigProjectsModal,
      clearSelection,
      createNewProject,
      showMessage,
      lucyFilePath,
      lucyFile,
      isUploading,
      fileInput,
      triggerFileInput,
      handleFileUpload,
      isProcessing,
      startCrawling,
      uploadLucyTest,
      uploadError,
      uploadSuccess,
      snackbar,
      confirmHandler,
      cancelHandler,
      reloadProjects,
      showGIGUsersModal,
      openGIGUsersModal,
      closeGIGUsersModal,
      selectGIGUser,
      showGIGProjectsModal,
      closeGIGProjectsModal,
      projectCrawlings,
      showProjectDetailModal,
      selectedProjectData,
      openProjectDetail,
      closeProjectDetailModal,
      selectedGIGUser,
      addSelectedUser,
      handleCreateChat,
      projectTree,
      handleShowMessage,
      chatSessions,
      openChatSession,
      formatDate,
    }
  }
})
</script>

<style scoped>
.header-row {
  background-color: #f5f5f5;
}

.blue-divider {
  height: 8px !important;
  background-color: #1976D2 !important;
}

.content-row {
  margin-top: 48px !important;
}

.v-application .mb-6 {
  margin-bottom: 24px !important;
}

.v-application .mt-4 {
  margin-top: 16px !important;
}

.v-chip-group {
  max-height: 100px;
  overflow-y: auto;
}

.v-main {
  background-color: #f5f5f5;
}

.v-card {
  border-radius: 8px;
}

.v-btn {
  text-transform: none;
}
</style>


